
import { defineComponent, onMounted } from "vue";
import MessengerPoweredByFooter from "./MessengerPoweredByFooter.vue";
import { useConversation } from "@/composables/conversation";
import MessengerMessage from "@/components/MessengerMessage.vue";
import { useEventBus } from "@vueuse/core";
import {
  MessageListScrollNotifyBus,
  MessageListScrollNotifyBusKey,
} from "@/types/MessageListScrollNotifyBus";

export default defineComponent({
  name: "MessengerMessageList",
  components: { MessengerMessage, MessengerPoweredByFooter },
  setup() {
    const { messages, conversation } = useConversation();
    const scrollNotifier = useEventBus<MessageListScrollNotifyBus>(
      MessageListScrollNotifyBusKey
    );

    onMounted(() => {
      scrollNotifier.emit();
    });

    return {
      messages, //: messages.value.filter(i => i.conversationId === conversation.value?.id)
    };
  },
});
